"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const constants_1 = require("@/app/shared/constants");
const actions_1 = require("@/app/SUMO/store/scheduler/actions");
const actions_2 = require("@/app/SUMO/store/user/actions");
const actions_3 = require("@/app/SUMOCEP/store/scheduler/actions");
const actions_4 = require("@/app/SUMOCEP/store/user/actions");
const redux_1 = require("redux");
const actions_5 = require("./actions");
exports.initialState = {
    serverUrl: '',
    serverType: null,
    serverEnvironment: null,
    serverPrefix: null,
    extensionIntegration: constants_1.ExtensionIntegration.BROWSER,
    isFetchingUserData: false,
    isAuthorized: false,
    isFetching: false,
    defaultHost: "ME" /* DefaultHost.ME */,
};
const serverUrl = (state = exports.initialState.serverUrl, action) => {
    switch (action.type) {
        case actions_5.GlobalActionTypes.SET_SERVER_URL:
            return action.payload;
        case actions_5.GlobalActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.serverUrl;
        default:
            return state;
    }
};
const serverType = (state = exports.initialState.serverType, action) => {
    switch (action.type) {
        case actions_5.GlobalActionTypes.SET_SERVER_TYPE:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_SUCCESS:
            return "SUMO" /* ServerType.SUMO */;
        case actions_4.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_SUCCESS:
            return "SALESFORCE" /* ServerType.SALESFORCE */;
        case actions_2.SUMO1UserActionTypes.HANDLE_LOGOUT:
        case actions_4.SUMOCEPUserActionTypes.HANDLE_LOGOUT:
        case actions_5.GlobalActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.serverType;
        default:
            return state;
    }
};
const serverEnvironment = (state = exports.initialState.serverEnvironment, action) => {
    switch (action.type) {
        case actions_5.GlobalActionTypes.SET_SERVER_ENVIRONMENT:
        case actions_4.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_SUCCESS:
            return action.payload;
        case actions_5.GlobalActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.serverEnvironment;
        default:
            return state;
    }
};
const serverPrefix = (state = exports.initialState.serverPrefix, action) => {
    switch (action.type) {
        case actions_5.GlobalActionTypes.SET_SERVER_PREFIX:
            return action.payload;
        case actions_5.GlobalActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.serverPrefix;
        default:
            return state;
    }
};
const extensionIntegration = (state = exports.initialState.extensionIntegration, action) => {
    switch (action.type) {
        case actions_5.GlobalActionTypes.SET_EXTENSION_INTEGRATION:
            return action.payload;
        case actions_5.GlobalActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.extensionIntegration;
        default:
            return state;
    }
};
const isFetchingUserData = (state = exports.initialState.isFetchingUserData, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_REQUEST:
        case actions_4.SUMOCEPUserActionTypes.GET_AUTHENTICATION_REQUEST:
            return true;
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_FAIL:
        case actions_4.SUMOCEPUserActionTypes.GET_AUTHENTICATION_SUCCESS:
        case actions_4.SUMOCEPUserActionTypes.GET_AUTHENTICATION_FAIL:
            return false;
        case actions_5.GlobalActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isFetchingUserData;
        default:
            return state;
    }
};
const isAuthorized = (state = exports.initialState.isAuthorized, action) => {
    switch (action.type) {
        case actions_5.GlobalActionTypes.SET_IS_AUTHORIZED:
        case actions_2.SUMO1UserActionTypes.SET_IS_AUTHORIZED:
        case actions_4.SUMOCEPUserActionTypes.SET_IS_AUTHORIZED:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_SUCCESS:
        case actions_4.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_SUCCESS:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.GET_SCHEDULER_DATA_FAILURE:
        case actions_1.SUMO1SchedulerActionTypes.GET_WORKSPACE_DATA_FAILURE:
        case actions_1.SUMO1SchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_UPSERT_INBOX_MEETING_TYPE_FAILURE:
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_BOOK_INSTANT_MEETING_FAILURE:
        case actions_3.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_FAILURE:
        case actions_3.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_FAILURE:
        case actions_3.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
        case actions_3.SUMOCEPSchedulerActionTypes.GET_ROOM_AND_RESOURCES_FAILURE:
        case actions_3.SUMOCEPSchedulerActionTypes.SCHEDULER_UPSERT_INBOX_BOOKING_PAGE_FAILURE:
        case actions_3.SUMOCEPSchedulerActionTypes.SCHEDULER_BOOK_PAGE_FAILURE:
            return false;
        case actions_5.GlobalActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isAuthorized;
        default:
            return state;
    }
};
const isFetching = (state = exports.initialState.isFetching, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_REQUEST:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_REQUEST:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_REQUEST:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_REQUEST:
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_FETCHING:
        case actions_4.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_REQUEST:
        case actions_4.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_REQUEST:
        case actions_4.SUMOCEPUserActionTypes.GET_AUTHENTICATION_FETCHING:
            return true;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_FAIL:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_FAIL:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_FAIL:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_FAIL:
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_FAIL:
        case actions_2.SUMO1UserActionTypes.SET_IS_FETCHING:
        case actions_4.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_SUCCESS:
        case actions_4.SUMOCEPUserActionTypes.GET_PREFIX_REQUEST_SUCCESS:
        case actions_4.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_SUCCESS:
        case actions_4.SUMOCEPUserActionTypes.GET_AUTHENTICATION_SUCCESS:
        case actions_4.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_FAIL:
        case actions_4.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_FAIL:
        case actions_4.SUMOCEPUserActionTypes.GET_PREFIX_REQUEST_FAIL:
        case actions_4.SUMOCEPUserActionTypes.GET_AUTHENTICATION_FAIL:
        case actions_4.SUMOCEPUserActionTypes.SET_IS_FETCHING:
            return false;
        case actions_5.GlobalActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isFetching;
        default:
            return state;
    }
};
const defaultHost = (state = exports.initialState.defaultHost, action) => {
    switch (action.type) {
        case actions_5.GlobalActionTypes.SET_DEFAULT_HOST:
            return action.payload;
        case actions_5.GlobalActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.defaultHost;
        default:
            return state;
    }
};
exports.default = (0, redux_1.combineReducers)({
    serverUrl,
    serverType,
    serverEnvironment,
    serverPrefix,
    extensionIntegration,
    isFetchingUserData,
    isAuthorized,
    isFetching,
    defaultHost,
});
